import styled from 'styled-components'

export const ExpenseTypeSelectorContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.typography.pxToRem(16)};
  width: 100%;
`
